import styled from "styled-components";

export const DisbursementReverifyWrapper = styled.div`
  ${
    "" /* border-radius: 1em;
  margin: 2em 0;
  padding: 1em;
  box-shadow: 0 0 11px -1px rgb(229, 229, 229);
  margin-bottom: 0px;
  padding-bottom: 0px; */
  }
  ${"" /* border-radius: 1em; */}
  ${"" /* margin: 2em 0; */}
  ${"" /* padding: 1em; */}
  box-shadow: 0 0 11px -1px rgb(229, 229, 229);
  margin-bottom: 0px;
  padding-bottom: 0px;
  margin-left: 0px;
  min-width: 286px;
  ${"" /* background-color: red; */}
  ${
    "" /* display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1; */
  }
  form {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: space-between;
    align-items: stretch;
  }

  .tickMark {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    padding-left: 1rem;
    padding-right: 1rem;
    font-size: 1.2em;
  }

  .professional-form-input {
    flex: auto;
    width: 47%;
  }

  .professional-form-title {
    display: flex;
    gap: 0.5em;
    justify-content: center;
    margin-bottom: 1em;
  }

  .professional-form-img {
    margin-top: 1em;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.75rem;
    width: 100%;
    flex-direction: column;
  }

  .professional-form-img img {
    width: 15vmax;
    max-width: 150px;
  }

  .heading2 {
    display: flex;
    justify-content: center;
    font-size: 5.8vw;
    margin-top: 10px;
    margin-bottom: 5px;
    font-weight: 400;
    color: #565f6b;
  }

  .otp-box {
    margin-left: 50px;
    margin-right: 50px;
    margin-top: 15px;
  }
  .timer-img {
    height: 15px;
    width: 15px;
    justif-content: center;
    margin-right: 4px;
  }

  .resnd-otp-row {
    display: flex;
    justify-content: center;
    color: #717171;
    font-size: 14px;
    margin-top: 15px;
    margin-bottom: 10px;
    align-items: center;
  }
  .resend-otp {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }

  .additional-confirm {
    display: flex;
    justify-content: space-evenly;
    flex-direction: row;
    // align-items: center;
    margin: 15px 0px 0px 0px;
  }

  .label-text{
    width: 90%;
    padding-left: 2em;
    padding-top: 2em;
    font-size: 18px;
    color: #6B6B6B;
  }

  .additional-confirm  > div > input[type="radio"] {
    align-self: center;
    height: 7px;
    padding: 6px;
    border: 1.5px solid rgb(200, 200, 200);
    border-radius: 8px;
    background-color: white;
  }

  .additional-confirm   > div > label {
    padding: 0 0rem;
    color: #6b6b6b;
    font-size: 18px;
    // margin-right: 40px;
  }

  #others{
    padding:0px;
    margin:0px;
  }

  .additional-confirm   > div > input[type="radio"]:checked {
    background-color: #cb3443;
  }

  @media only screen and (max-width: 768px) {
    border-radius: 0;
    padding: 0;
    box-shadow: none;

    .professional-form-input {
      width: 100%;
    }

    .professional-form-input-small {
      max-width: 48%;
    }
  }

  @media only screen and (min-width: 601px) {
    form {
      gap: 12px;
    }
  }
`;
